import { useEffect } from 'react';

import { Platform } from 'react-native';

import { clearAllLocalDataForEnvSwitch } from 'components/env-picker';
import {
  RBIEnv,
  allowEnvPicker,
  region as currentRegion,
  env,
  setPickedEnvConfig,
  shouldShowEnvPickerAtStart,
} from 'utils/environment';
import { Region } from 'utils/environment/types';

export const useApplyEnvRegionFromUrl = (): void => {
  useEffect(() => {
    if (Platform.OS !== 'web') {
      return;
    }
    try {
      const search = window?.location?.search || '';
      if (!search) {
        return;
      }
      const urlParams = new URLSearchParams(search);
      const envParam = urlParams.get('env') || undefined;
      const regionParam = urlParams.get('region') || undefined;
      if (!allowEnvPicker || (!envParam && !regionParam)) {
        return;
      }

      const isEnvValid = envParam && Object.values(RBIEnv).includes(envParam as RBIEnv);
      const newEnv = isEnvValid ? (envParam as RBIEnv) : env();
      const newRegion = ((regionParam as Region) || currentRegion) as Region;

      const needsChange =
        shouldShowEnvPickerAtStart() || newEnv !== env() || newRegion !== currentRegion;
      if (!needsChange) {
        return;
      }

      (async () => {
        try {
          await clearAllLocalDataForEnvSwitch();
        } finally {
          setPickedEnvConfig({ env: newEnv, buildRegion: newRegion });
          // Keep current URL (including query) so autoselect can proceed after reload
          window.location.reload();
        }
      })();
    } catch (e) {
      // no-op: fallback to normal overlay flow
    }
  }, []);
};
